import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import {States} from "../../shared/config/constant.module";
import template from './qualificationsReport.tpl.html';
import {ICommonQueryingReport} from "./commonQueryingReport";
import {StateParams} from "../../common";
import {apsEnums} from "../../shared/dto/aps.enums";
import {Plant} from "../../models/navigation";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {EnumOption, UIUtilityService} from "../../services/utility/uiUtility.service";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import DateUtilityService from "../../services/utility/dateutility.service";
import ReportServiceName, {ReportService} from "../../services/reports/report.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";

let requires = [NavigationServiceName, ReportServiceName, LoaderServiceName];
  
interface QualificationsReportController extends ICommonQueryingReport {
}

interface QualificationsReportParams extends StateParams {
  reportPlantId: string;
  reportShopId: string;
  startDate: string;
  endDate: string;
  location: apsEnums.Location;
  exceptionTime: string;
  exceptionsOnly: string;
  autoRun: boolean;
}

class QualificationsReportCtrl implements QualificationsReportController {
  form: angular.IFormController;
  requirePlantSelection: boolean;
  requireShopSelection: boolean;
  plants: Plant[];
  selectedPlant: Plant;
  selectedShop: apsViewModels.ShopNavigation;
  startDate: Date;
  endDate: Date;
  uiStartDate: Date;
  uiEndDate: Date;
  location: apsEnums.Location;
  locations: EnumOption[];
  exceptionTime: number;
  exceptionsOnly: boolean;
  searchPerformed: boolean;
  qualifications: apsViewModels.QualificationReportItem[];

  $state: angular.ui.IStateService;
  navigationService: NavigationService;
  reportService: ReportService;
  uiUtilityService: UIUtilityService;
  loaderService: LoaderService;
  private $stateParams: QualificationsReportParams;
  private $q: angular.IQService;
  private $timeout: angular.ITimeoutService;

  constructor(
    $q: angular.IQService,
    $timeout: angular.ITimeoutService,
    $state: angular.ui.IStateService,
    $stateParams: QualificationsReportParams,
    navigationService: NavigationService,
    reportService: ReportService,
    uiUtilityService: UIUtilityService,
    loaderService: LoaderService) {

    this.$q = $q;
    this.$timeout = $timeout;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.navigationService = navigationService;
    this.reportService = reportService;
    this.uiUtilityService = uiUtilityService;
    this.loaderService = loaderService;

    this.requirePlantSelection = true;
    this.requireShopSelection = true;

    var now = moment().add(1, 'hours').startOf('hour');
    this.uiEndDate = now.toDate();
    this.uiStartDate = now.clone().subtract(1, 'days').toDate();
    this.location = apsEnums.Location.ColdEnd;
    this.locations = uiUtilityService.getListOptionsFromEnum(apsEnums.Location, 1);
    this.exceptionsOnly = false;
    this.searchPerformed = false;
    this.qualifications = [];

    var promise = navigationService.getNavigation().then((navModel) => {
      this.plants = navModel.plants();
      this.selectedPlant = navModel.selectedPlant;
      this.updatePlant();
      this.selectedShop = navModel.selectedShop;

      return this.loadState($stateParams);
    });

    loaderService.loadingPromise(promise);
  }

  updatePlant(): void {
    this.selectedShop = null;
  }

  loadState(params: QualificationsReportParams): angular.IPromise<any> {
    if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
      var plant = _.find(this.plants, {id: params.reportPlantId});
      if (plant) {
        var shop = _.find(plant.shops, {id: params.reportShopId});
        if (shop) {
          this.selectedPlant = plant;
          this.selectedShop = shop;
        }
      }
    }

    DateUtilityService.setReportDates(this, params, this.$timeout);

    if (params.location) {
      var location = _.find(this.locations, { value: +params.location }); // !!!
      if (location) {
        this.location = location.value;
      }
    }

    if (params.exceptionTime !== undefined) {
      this.exceptionTime = +params.exceptionTime; // !!!
    }

    if (params.exceptionsOnly === 'true') {
      this.exceptionsOnly = true;
    }

    if (params.autoRun) {
      return this.runReport();
    }

    return this.$q.when();
  }

  saveState(): void {
    var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
    if (reportShopId === this.$stateParams.shopId) {
      reportShopId = undefined;
    }
    var params: QualificationsReportParams = {
      plantId: this.$stateParams.plantId,
      shopId: this.$stateParams.shopId,
      userId: this.$stateParams.userId,
      reportPlantId: (reportShopId && this.selectedPlant) ? this.selectedPlant.id : undefined,
      reportShopId: reportShopId,
      startDate: this.startDate ? this.startDate.toISOString() : undefined,
      endDate: this.endDate ? this.endDate.toISOString() : undefined,
      location: this.location,
      exceptionTime: this.exceptionTime ? this.exceptionTime.toString() : undefined,
      exceptionsOnly: this.exceptionsOnly.toString(),
      autoRun: true
    };

    this.$state.transitionTo(this.$state.current.name, params);
  }

  generateReport(): angular.IPromise<any> {
    if (this.form.$invalid) {
      return;
    }

    this.saveState();

    var promise = this.runReport();
    this.loaderService.loadingPromise(promise);
    return promise;
  }

  formatTime(time: Date): string {
    return DateUtilityService.formatTime(time, this.selectedPlant.timeZoneId);
  }

  exportToCsv = function() { 
    return _.map<apsViewModels.QualificationReportItem, any>(this.qualifications, (x) => {
      return {
        cavity: x.cavity,
        category: x.category,
        startTime: this.formatTime(x.startTime),
        endTime: this.formatTime(x.endTime),
        duration: x.duration,
        cause: x.cause
      };
    });
  }

  private runReport(): angular.IPromise<any> {
    return this.reportService.getQualificationsReport(
      this.selectedShop.id,
      this.startDate,
      this.endDate,
      this.location,
      this.exceptionTime,
      this.exceptionsOnly)
      .then((qualifications) => {
        this.qualifications = qualifications;
        this.searchPerformed = true;
      });
  }
}

export default angular.module('aps.controller.qualificationsReport', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.QUALIFICATIONS_REPORT,
      url: '/admin/reports/qualifications?startDate&endDate&location&exceptionTime&exceptionsOnly&autoRun&reportPlantId&reportShopId',
      params: {
        startDate: {dynamic: true},
        endDate: {dynamic: true},
        location: {dynamic: true},
        exceptionTime: {dynamic: true},
        exceptionsOnly: {dynamic: true},
        autoRun: {dynamic: true},
        reportPlantId: {dynamic: true},
        reportShopId: {dynamic: true},
      },
      controller: 'QualificationsReportCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Qualification Exceptions Report'
      }
    });
  })
  .controller('QualificationsReportCtrl', QualificationsReportCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/reports/qualificationsReport.controller.ts